import Score from "./score";

class Game extends Score {

  type_game = 'big_round'
  constructor(store, default_game, urls = window.URLS) {
    super(store, default_game, urls, 'big_round')
  }
}

export default Game